import type {
  BootstrapResponse,
  OnboardingResponse,
} from './onboarding-contracts'

export type OnboardingDestination =
  | 'dashboard'
  | 'communications'
  | 'legacy-dashboard'
  | 'nexhealth'
  | 'nexhealth-location'
  | 'onboarding'
  | 'profile'
  | 'provisioning'
  | 'review'
  | 'without-pms'
  | 'scheduling'
  | 'verify-email'

export function routeOnboardingResponse(
  response: OnboardingResponse
): OnboardingDestination {
  if (response.schemaVersion === 1) return 'legacy-dashboard'
  if (response.principalType === 'NON_OWNER') return 'dashboard'
  if (
    !response.emailVerified ||
    response.status === 'EMAIL_VERIFICATION_REQUIRED'
  ) {
    return 'verify-email'
  }
  if (response.status === 'PROFILE_REQUIRED') return 'profile'
  if (response.status === 'SCHEDULING_REQUIRED') return response.pmsMode === 'PMS_INTENTIONALLY_DISABLED' ? 'without-pms' : 'scheduling'
  if (response.status === 'COMMUNICATIONS_REQUIRED') return 'communications'
  if (response.status === 'REVIEW_REQUIRED') return 'review'
  if (response.status === 'PROVISIONING' || response.status === 'VALIDATING') {
    return 'provisioning'
  }
  if (response.status === 'LOCATION_REQUIRED') return 'nexhealth-location'
  if (
    response.status === 'CRM_CREDENTIAL_REQUIRED' ||
    response.status === 'CRM_DISCOVERING' ||
    (response.status === 'ACTION_REQUIRED' &&
      [
        'CRM_CREDENTIAL_REQUIRED',
        'CRM_DISCOVERING',
        'LOCATION_REQUIRED',
      ].includes(response.resumeState))
  ) {
    return 'nexhealth'
  }
  return response.status === 'READY' ? 'dashboard' : 'onboarding'
}

export function routeBootstrapResponse(
  response: BootstrapResponse
): Exclude<OnboardingDestination, 'legacy-dashboard'> {
  if (
    !response.emailVerified ||
    response.status === 'EMAIL_VERIFICATION_REQUIRED'
  ) {
    return 'verify-email'
  }
  if (response.status === 'PROFILE_REQUIRED') return 'profile'
  return response.status === 'READY' ? 'dashboard' : 'onboarding'
}

export function destinationPath(destination: OnboardingDestination): string {
  if (destination === 'verify-email') return '/onboarding/verify-email'
  if (destination === 'profile') return '/onboarding/profile'
  if (destination === 'nexhealth') return '/onboarding/nexhealth'
  if (destination === 'nexhealth-location') {
    return '/onboarding/nexhealth/location'
  }
  if (destination === 'scheduling') return '/onboarding/scheduling'
  if (destination === 'communications') return '/onboarding/communications'
  if (destination === 'without-pms') return '/onboarding/without-pms'
  if (destination === 'review') return '/onboarding/review'
  if (destination === 'provisioning') return '/onboarding/provisioning'
  if (destination === 'onboarding') return '/onboarding'
  return '/'
}
